import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\ModelNotification\ShareAnswerModelNotificationController::__invoke
* @see app/Http/Controllers/ModelNotification/ShareAnswerModelNotificationController.php
* @route '/api/model-notification/create-response/{group_id}/{type}'
*/
const ShareAnswerModelNotificationController = (args: { group_id: string | number, type: string | number } | [group_id: string | number, type: string | number ], options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: ShareAnswerModelNotificationController.url(args, options),
    method: 'get',
})

ShareAnswerModelNotificationController.definition = {
    methods: ["get","head"],
    url: '/api/model-notification/create-response/{group_id}/{type}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\ModelNotification\ShareAnswerModelNotificationController::__invoke
* @see app/Http/Controllers/ModelNotification/ShareAnswerModelNotificationController.php
* @route '/api/model-notification/create-response/{group_id}/{type}'
*/
ShareAnswerModelNotificationController.url = (args: { group_id: string | number, type: string | number } | [group_id: string | number, type: string | number ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            group_id: args[0],
            type: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        group_id: args.group_id,
        type: args.type,
    }

    return ShareAnswerModelNotificationController.definition.url
            .replace('{group_id}', parsedArgs.group_id.toString())
            .replace('{type}', parsedArgs.type.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\ModelNotification\ShareAnswerModelNotificationController::__invoke
* @see app/Http/Controllers/ModelNotification/ShareAnswerModelNotificationController.php
* @route '/api/model-notification/create-response/{group_id}/{type}'
*/
ShareAnswerModelNotificationController.get = (args: { group_id: string | number, type: string | number } | [group_id: string | number, type: string | number ], options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: ShareAnswerModelNotificationController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ModelNotification\ShareAnswerModelNotificationController::__invoke
* @see app/Http/Controllers/ModelNotification/ShareAnswerModelNotificationController.php
* @route '/api/model-notification/create-response/{group_id}/{type}'
*/
ShareAnswerModelNotificationController.head = (args: { group_id: string | number, type: string | number } | [group_id: string | number, type: string | number ], options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: ShareAnswerModelNotificationController.url(args, options),
    method: 'head',
})

export default ShareAnswerModelNotificationController